export const goToTop = () => {
  window.scrollTo({ top: 120, behavior: 'smooth' })
}
